import React from 'react'
import { Carousel } from 'react-bootstrap'

export default function CarouselProfesional() {
    return (
        <Carousel fade>
            <Carousel.Item>
                <img width={"100%"} height={"411px"} style={{objectFit: "cover"}} src="https://img.freepik.com/foto-gratis/hermosa-joven-doctora-mirando-camara-oficina_1301-7807.jpg?semt=ais_hybrid&w=740&q=80" alt="" />
                {/* <ExampleCarouselImage text="First slide" /> */}
                <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                {/* <ExampleCarouselImage text="Second slide" /> */}
                <img width={"100%"} height={"411px"} style={{objectFit: "cover"}} src="https://www.ama.com.au/sites/default/files/inline-images/317_MG_6618%20-%20High%20Res%20crop.jpg" alt="" />
                <Carousel.Caption>
                    <h3>Second slide label</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                {/* <ExampleCarouselImage text="Third slide" /> */}
                <img width={"100%"} height={"411px"} style={{objectFit: "cover"}} src="https://www.future-doctor.de/wp-content/uploads/2024/08/shutterstock_2480850611.jpg" alt="" />
                <Carousel.Caption>
                    <h3>Third slide label</h3>
                    <p>
                        Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    )
}
